import api from "../../client";
import {
  AccountDetailResponseData,
  CreateAccountPayload,
} from "../../types/account";

export const createAccountRequest = async (
  payload: CreateAccountPayload,
): Promise<AccountDetailResponseData> => {
  const { data } = await api.post<AccountDetailResponseData>(
    `/account`,
    payload,
  );

  return data;
};
